import React from 'react';
import { L } from '../../styles/theme';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  /** Right-aligned actions (buttons, switches, etc.). */
  extra?: React.ReactNode;
  /** Override default bottom margin. */
  marginBottom?: number;
}

/**
 * Заголовок страницы «Линии»: компактная строка — название, приглушённый
 * подзаголовок в той же строке, действия справа.
 */
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  extra,
  marginBottom = 16,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom, flexWrap: 'wrap' }}>
      {icon ? <span style={{ fontSize: 16, color: L.muted, display: 'flex' }}>{icon}</span> : null}
      <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600, letterSpacing: '-0.01em', color: L.ink }}>
        {title}
      </h2>
      {subtitle ? <span style={{ fontSize: 12, color: L.faint }}>{subtitle}</span> : null}
      <span style={{ flex: 1 }} />
      {extra ? <span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>{extra}</span> : null}
    </div>
  );
};

export default PageHeader;
